import React, { useState , useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth, firestore, storage } from '../firebase'; 
import './SignUp.css';
import Header from './Header';
import firebase from 'firebase/compat/app';



const SignUp = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [age, setAge] = useState('');
  const [gender, setGender] = useState('');
  const [country, setCountry] = useState('');
  const [interests, setInterests] = useState([]);
  const [profileImage, setProfileImage] = useState(null); 
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState('');

  useEffect(() => {
    const fetchCourses = async () => {
      const db = firebase.firestore();

      const coursesSnapshot = await db.collection('courses').get();
      const courses = coursesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      setCourses(courses);
    };

    fetchCourses();
  }, []);




  const handleSignUp = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      alert("Passwords don't match");
      return;
    }

    try {
      // Create user with email and password
      const { user } = await auth.createUserWithEmailAndPassword(email, password);

      // Update user profile display name
      await user.updateProfile({ displayName: name });

      // Rename profile image before uploading
      const fileExtension = profileImage.name.split('.').pop();
      const renamedFilename = `${user.uid}.${fileExtension}`;
      const renamedImage = new File([profileImage], renamedFilename);

      // Upload renamed profile image to Storage
      const storageRef = storage.ref();
      const imageRef = storageRef.child(`profileImages/${user.uid}/${renamedFilename}`);
      await imageRef.put(renamedImage);
      const imageUrl = await imageRef.getDownloadURL();

      // Create user details object
      const userDetails = {
        uid: user.uid,
        name: name,
        email: email,
        age: age,
        gender: gender,
        country: country,
        interests: interests,
        imageUrl: imageUrl, 
        signupTimestamp: new Date().toISOString() 
      };

      // Store user details in Firestore
      await firestore.collection('users').doc(user.uid).set(userDetails);

      // Navigate to student dashboard
      navigate('/studentdashboard');

    } catch (error) {
      console.error('Error signing up:', error.message);
    }
  };

  // Handle file input change
  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setProfileImage(e.target.files[0]);
    }
  };


  return (
    <><Header /><div className="signup-container">
      <h2>Sign Up</h2>
      <form className="signup-form" onSubmit={handleSignUp}>
        <div className="form-group">
          <label htmlFor="profileImage">Profile Image:</label>
          <input
            type="file"
            id="profileImage"
            accept="image/*"
            onChange={handleFileChange}
            required />
        </div>
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required />
        </div>
        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm Password:</label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required />
        </div>
        <div className="form-group">
          <label htmlFor="age">Age:</label>
          <input
            type="number"
            id="age"
            value={age}
            onChange={(e) => setAge(e.target.value)}
            required />
        </div>
        <div className="form-group">
          <label htmlFor="gender">Gender:</label>
          <select
            id="gender"
            value={gender}
            onChange={(e) => setGender(e.target.value)}
            required
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="country">Country:</label>
          <input
            type="text"
            id="country"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            required />
        </div>
        <div className="form-group">
          <label htmlFor="interests">Interests:</label>
          <input
            type="text"
            id="interests"
            value={interests}
            onChange={(e) => setInterests(e.target.value.split(','))}
            required />
        </div>
        <div className="form-group">
  <label htmlFor="course">Course:</label>
  <select
    id="course"
    value={selectedCourse}
    onChange={(e) => setSelectedCourse(e.target.value)}
    required
  >
    <option value="">Select Course</option>
    {courses.map(course => (
      <option key={course.id} value={course.id}>{course.name}</option>
    ))}
  </select>
</div>
        <button type="submit">Sign Up</button>
      </form>
      <p>
        Already have an account? <Link to="/signin">Sign In</Link>
      </p>
    </div></>
  );
};

export default SignUp;
